/**
 * /dev/api — API documentation (Swagger UI). P2 from ADR-0007.
 *
 * Renders openapi.yaml через Swagger UI CDN (zero npm deps).
 * Source spec served at /openapi.yaml (статика в Caddy → /srv/web/openapi.yaml).
 */
import { useEffect, useRef } from 'react'
import { ThemeToggle } from '@/components/ui'
import { Logo } from '@/components/auth/Logo'

const SWAGGER_CSS = 'https://cdn.jsdelivr.net/npm/swagger-ui-dist@5.17.14/swagger-ui.css'
const SWAGGER_JS = 'https://cdn.jsdelivr.net/npm/swagger-ui-dist@5.17.14/swagger-ui-bundle.js'
const SWAGGER_PRESET_JS = 'https://cdn.jsdelivr.net/npm/swagger-ui-dist@5.17.14/swagger-ui-standalone-preset.js'

declare global {
  interface Window {
    SwaggerUIBundle?: any
    SwaggerUIStandalonePreset?: any
  }
}

export function ApiDocs() {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const ensureLink = (id: string, href: string) => {
      if (document.getElementById(id)) return
      const link = document.createElement('link')
      link.id = id
      link.rel = 'stylesheet'
      link.href = href
      document.head.appendChild(link)
    }
    const ensureScript = (id: string, src: string) =>
      new Promise<void>((resolve, reject) => {
        if (document.getElementById(id)) return resolve()
        const s = document.createElement('script')
        s.id = id
        s.src = src
        s.async = false
        s.onload = () => resolve()
        s.onerror = () => reject(new Error(`Failed to load ${src}`))
        document.body.appendChild(s)
      })

    ensureLink('swagger-ui-css', SWAGGER_CSS)
    ;(async () => {
      try {
        await ensureScript('swagger-ui-bundle', SWAGGER_JS)
        await ensureScript('swagger-ui-preset', SWAGGER_PRESET_JS)
        if (!containerRef.current) return
        if (typeof window.SwaggerUIBundle !== 'function') return
        window.SwaggerUIBundle({
          url: '/openapi.yaml',
          domNode: containerRef.current,
          deepLinking: true,
          presets: [window.SwaggerUIBundle.presets.apis, window.SwaggerUIStandalonePreset],
          layout: 'BaseLayout',
          docExpansion: 'list',
          tryItOutEnabled: true,
        })
      } catch (e) {
        if (containerRef.current) {
          containerRef.current.innerHTML = `<div class="p-6 text-sm text-status-danger-text">Не удалось загрузить Swagger UI. Проверь /openapi.yaml и подключение к интернету.</div>`
        }
      }
    })()
  }, [])

  return (
    <div className="min-h-screen bg-surface-canvas text-text-primary">
      <header className="sticky top-0 z-10 bg-surface-canvas border-b border-border px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Logo size="md" tone="brand" />
          <span className="text-text-muted text-sm">/ API Reference</span>
        </div>
        <div className="flex items-center gap-3">
          <a href="/dev/components" className="text-sm text-text-link font-medium">← Components</a>
          <a href="/openapi.yaml" target="_blank" rel="noreferrer" className="text-sm text-text-link font-medium">openapi.yaml ↓</a>
          <ThemeToggle />
        </div>
      </header>

      <main className="bg-surface-raised">
        <div ref={containerRef} className="swagger-ui-container max-w-7xl mx-auto" />
      </main>
    </div>
  )
}
